import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { resources, defaultNS } from "./resources";

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources,
    lng: "en",
    fallbackLng: "en",
    defaultNS,
    ns: ["common", "projectHome", "createProject", "settings", "projects"],
    interpolation: { escapeValue: false },
    react: { useSuspense: false }
  });
}

export default i18n;

export const PROJECT_LANGUAGE_TO_LNG: Record<string, string> = {
  english: "en",
  japanese: "ja"
};

export function projectLanguageToLng(projectLanguage?: string | null): string {
  if (!projectLanguage) return "en";
  return PROJECT_LANGUAGE_TO_LNG[projectLanguage.trim().toLowerCase()] ?? "en";
}

let userDefaultLng = "en";

export const setUserDefaultLng = (lng: string) => {
  userDefaultLng = lng;
};

export const getUserDefaultLng = () => userDefaultLng;
